<template>
  <Adminlte>
    <p>
      <button class="btn btn-sm btn-success" @click="createPartner()"><i class="fa fa-plus"></i>&nbsp Novo</button>
    </p>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Parceiros</h3>
      </div>
      <div class="box-body">
        <table id="partners-table" class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="partner in partnersCollection" v-if="Object.keys(partnersCollection).length > 0">
              <td>{{partner.name}}</td>
              <td>{{partner.email}}</td>
              <td>
                 <button
                   class="btn btn-xs btn-primary"
                   @click="editPartner(partner.id)">
                   <i class="fa fa-pencil"></i>
                   &nbsp Editar
                 </button>
                <button
                  class="btn btn-xs btn-danger"
                  @click="onDeletePartnerButtonClick(partner.id)"
                  data-toggle="modal"
                  data-target="#delete-partner-modal">
                  <i class="fa fa-close"></i>
                  &nbsp; Excluir
                </button>
                <button
                  class="btn btn-xs btn-warning recover-password"
                  @click="onRecoverPasswordPartnerButtonClick(partner.id)"
                  data-toggle="modal"
                  data-target="#recover-password-modal">
                  <i class="fa fa-unlock-alt"></i>
                  &nbsp; Recuperar Senha
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <notifier ref="notifier"></notifier>

    <div class="modal fade" id="delete-partner-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Excluir Parceiro</h4>
          </div>
          <div class="modal-body">
            <p>
              Ao clicar em "Ok" o parceiro será excluído do sistema.
              Esta ação é irreversível! Deseja continuar?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button id="delete-partner-modal-confirm" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="recover-password-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Recuperar Senha</h4>
          </div>
          <div class="modal-body">
            <p>Ao clicar em "Ok" um link para criação de uma nova senha será enviado por email ao parceiro. Deseja continuar?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button id="recover-password-modal-confirm" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
import PartnerClient from '@/services/resource_client/partner'
import Notifier from '@/components/elements/Notifier'

export default {
  name: 'Partners',
  components: { Adminlte, Notifier },
  data: function () {
    return {
      partnersCollection: [],
      deletePartnerId: null,
      recoverPasswordPartnerId: null
    }
  },
  created () {
    this.fetchPartners().then(this.reloadTable)
  },
  mounted () {
    this.bindConfirmDeletePartner()
    this.bindConfirmPasswordRecovery()
  },
  methods: {
    fetchPartners () {
      return PartnerClient.cget()
        .then(r => {
          this.partnersCollection = []

          for (const object of Object.values(r.data)) {
            if (!object.hasOwnProperty('id')) { return }
            this.partnersCollection.push(object)
          }
        })
    },
    reloadTable () {
      $('#partners-table').DataTable()
    },
    createPartner () {
      this.$router.push({name: 'CreatePartner'})
    },
    editPartner (id) {
      this.$router.push({name: 'EditPartner', params: { id: id }})
    },
    onDeletePartnerButtonClick (id) {
      this.deletePartnerId = id
    },
    bindConfirmDeletePartner () {
      let that = this
      $('body').off('click', '#delete-partner-modal-confirm')
        .on('click', '#delete-partner-modal-confirm', function (e) {
          that.deletePartner()
        })
    },
    deletePartner () {
      PartnerClient.delete(this.deletePartnerId)
        .then(r => {
          this.fetchPartners().then(this.reloadTable)
          this.showPartnerDeleteSuccessNotification()
        })
        .catch(e => {
          this.showPartnerDeleteErrorNotification()
        })
    },
    showPartnerDeleteSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'O parceiro foi excluído do sistema!' })
    },
    showPartnerDeleteErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir o parceiro! Entre em contato com a equipe de desenvolvimento.' })
    },
    onRecoverPasswordPartnerButtonClick (id) {
      this.recoverPasswordPartnerId = id
    },
    bindConfirmPasswordRecovery () {
      let self = this
      $('body').off('click', '#recover-password-modal-confirm')
        .on('click', '#recover-password-modal-confirm', function (e) {
          self.recoverPartnerPassword()
        })
    },
    recoverPartnerPassword () {
      PartnerClient.recoverPassword(this.recoverPasswordPartnerId)
        .then(r => {
          this.showPartnerRecoverPasswordSuccessNotification()
        })
        .catch(e => {
          this.showPartnerRecoverPasswordErrorNotification()
        })
    },
    showPartnerRecoverPasswordSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'Instruções de redefinição de senha foram enviadas por e-mail para o parceiro!' })
    },
    showPartnerRecoverPasswordErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao tentar recuperar a senha do parceiro! Entre em contato com a equipe de desenvolvimento.' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Partners.vue?f85de062